<template>
  <div>
    <div id="test_3">
      <img
        ref="img"
        src="../assets/signation.png"
        @mousedown="start"
        @mouseup="stop"
        @mousemove="move"
        :style="style"
      />
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      canDrag: false,
      x0: 0,
      y0: 0,
      x1: 0,
      y1: 0,
      style: null,
    };
  },
  methods: {
    start(e) {
      console.log('鼠标落下')
      //鼠标左键点击
      if (e.button == 0) {
        this.canDrag = true;
        //记录鼠标指针位置
        this.x0 = e.clientX;
        this.y0 = e.clientY;
      }
    },
    stop(e) {
      console.log('鼠标移动')
      this.canDrag = false;
    },
    move: function (e) {
      console.log(e)
      console.log(this)
      if (this.canDrag == true) {
        this.x1 = e.clientX;
        this.y1 = e.clientX;
        let x = this.x1 - this.x0;
        let y = this.y1 - this.y0;
        let img = this.$refs.img;
        this.style = `left:${img.offsetLeft + x}px;top:${img.offsetTop + y}px`;
        this.x0 = this.x1;
        this.y0 = this.y1;
      }
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue